/* Default collection template behaviour - product card, wishlist and quick-view modal.
   Loaded only by sections/c-official-collection.liquid. Uses event delegation so it keeps
   working after facets.js re-renders the product grid.
   Generalized from assets/c-bestsellers.js — the quick view modal (#c-bs-quickview-modal,
   .c-bs-qv* classes) is intentionally shared with Best Sellers, not renamed. */
(function () {
  'use strict';

  /* =========================================================================
   * Quick View modal
   * ======================================================================= */
  var lastFocused = null;

  function modalEls() {
    var overlay = document.getElementById('c-bs-quickview-modal');
    if (!overlay) return null;
    return {
      overlay: overlay,
      content: overlay.querySelector('[data-qv-content]')
    };
  }

  function openModal() {
    var m = modalEls();
    if (!m) return;
    lastFocused = document.activeElement;
    m.overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = m.overlay.querySelector('[data-qv-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var m = modalEls();
    if (!m) return;
    m.overlay.hidden = true;
    m.content.innerHTML = '';
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function openQuickView(url) {
    if (!url) return;
    var m = modalEls();
    if (!m) { window.location.href = url; return; }

    m.content.innerHTML =
      '<div class="c-bs-qv-loading"><svg aria-hidden="true" class="spinner" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg><span>Loading...</span></div>';
    openModal();

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'view=quickview')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        m.content.innerHTML = html;
        initQuickView(m.content);
        syncHearts();
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-quickview-open]');
    if (opener) {
      event.preventDefault();
      openQuickView(opener.getAttribute('data-product-url'));
      return;
    }
    if (event.target.closest('[data-qv-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var overlay = document.getElementById('c-bs-quickview-modal');
      if (overlay && !overlay.hidden) closeModal();
    }
  });

  // Close the quick view modal once product-form successfully adds the item to the cart.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source !== 'product-form') return;
      var overlay = document.getElementById('c-bs-quickview-modal');
      if (overlay && !overlay.hidden) closeModal();
    });
  }

  /* ---- Quick View: gallery + variant selection ---- */
  function formatMoney(cents, sample) {
    var amount = cents / 100;
    var symbolMatch = sample.match(/^[^\d]*/);
    var symbol = symbolMatch ? symbolMatch[0] : '';
    var hasDecimals = /[.,]\d{2}\s*$/.test(sample);
    var str = hasDecimals ? amount.toFixed(2) : String(Math.round(amount));
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + parts.join('.');
  }

  function initQuickView(root) {
    var dataEl = root.querySelector('[data-qv-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    // Thumbnails -> swap main image
    var mainImg = root.querySelector('[data-qv-main-img]');
    root.querySelectorAll('[data-qv-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
        root.querySelectorAll('[data-qv-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Variant pills
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-qv-value]'));
    var idInput = root.querySelector('[data-qv-id]');
    var priceEl = root.querySelector('[data-qv-price]');
    var compareEl = root.querySelector('[data-qv-compare]');
    var atc = root.querySelector('.c-bs-qv__atc');
    var atcText = atc ? atc.querySelector('span') : null;
    var priceSample = priceEl ? priceEl.textContent.trim() : '';

    function selectedByPosition() {
      var sel = {};
      pills.forEach(function (p) {
        if (p.classList.contains('is-selected')) sel[p.getAttribute('data-opt-position')] = p.getAttribute('data-value');
      });
      return sel;
    }

    function variantMatches(variant, sel) {
      return Object.keys(sel).every(function (pos) {
        return variant.options[parseInt(pos, 10) - 1] === sel[pos];
      });
    }

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        if (variantMatches(variants[i], sel)) return variants[i];
      }
      return null;
    }

    function update() {
      var sel = selectedByPosition();
      var variant = findVariant(sel);

      // availability per pill (given the other currently-selected options)
      pills.forEach(function (pill) {
        var pos = pill.getAttribute('data-opt-position');
        var trySel = {};
        Object.keys(sel).forEach(function (k) { trySel[k] = sel[k]; });
        trySel[pos] = pill.getAttribute('data-value');
        var candidate = null;
        for (var i = 0; i < variants.length; i++) {
          if (variantMatches(variants[i], trySel)) { candidate = variants[i]; break; }
        }
        pill.disabled = !(candidate && candidate.available);
      });

      if (idInput) idInput.value = variant ? variant.id : '';

      if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, priceSample);
      if (compareEl) {
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, priceSample);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (variant && variant.featured_image && variant.featured_image.src && mainImg) {
        mainImg.src = variant.featured_image.src;
      }

      if (atc) {
        var buyable = variant && variant.available;
        atc.setAttribute('aria-disabled', buyable ? 'false' : 'true');
        if (atcText) atcText.textContent = buyable ? 'Add to cart' : (variant ? 'Sold out' : 'Unavailable');
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var pos = pill.getAttribute('data-opt-position');
        root.querySelectorAll('[data-qv-value][data-opt-position="' + pos + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        update();
      });
    });

    update();
  }

  /* =========================================================================
   * Wishlist (Swym) - driven via the Swym API so each heart reflects only its
   * own product (native buttons take over styling and mark every button on add).
   * ======================================================================= */
  var swym = null;
  var wishlistEmpis = new Set();

  function syncHearts() {
    document.querySelectorAll('[data-swym-heart]').forEach(function (btn) {
      var active = wishlistEmpis.has(String(btn.getAttribute('data-empi')));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function fetchAndSync() {
    if (!swym) return;
    swym.fetchLists({
      callbackFn: function (lists) {
        window.swymWishLists = lists;
        window.swymSelectedListId = lists && lists[0] && lists[0].lid;
        wishlistEmpis = new Set();
        (lists || []).forEach(function (list) {
          (list.listcontents || []).forEach(function (item) {
            wishlistEmpis.add(String(item.empi));
          });
        });
        syncHearts();
      },
      errorFn: function () {}
    });
  }

  function onSwymReady(swat) {
    if (swym) return;
    swym = swat;
    fetchAndSync();
    try {
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function () {
        window.swymWishLists = null; setTimeout(fetchAndSync, 300);
      });
      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function () {
        window.swymWishLists = null; setTimeout(fetchAndSync, 300);
      });
    } catch (e) {}
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymReady);
  if (window._swat) onSwymReady(window._swat);

  /* Cards appended by c-infinite-scroll.js arrive after the initial sync. */
  document.addEventListener('sl:grid:append', syncHearts);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-swym-heart]');
    if (!btn) return;
    event.preventDefault();
    if (!swym) return;

    var product = {
      empi: parseInt(btn.getAttribute('data-empi'), 10),
      epi: parseInt(btn.getAttribute('data-epi'), 10),
      du: btn.getAttribute('data-du')
    };
    var wasActive = btn.classList.contains('is-active');
    var lid = window.swymSelectedListId;
    btn.classList.toggle('is-active', !wasActive);
    btn.setAttribute('aria-pressed', !wasActive ? 'true' : 'false');
    var revert = function () {
      btn.classList.toggle('is-active', wasActive);
      btn.setAttribute('aria-pressed', wasActive ? 'true' : 'false');
    };

    if (wasActive) {
      wishlistEmpis.delete(String(product.empi));
      swym.deleteFromList(lid, product, function () {}, revert);
    } else {
      wishlistEmpis.add(String(product.empi));
      swym.addToList(lid, product, function () {}, revert);
    }
  });

  // Re-apply wishlist state after facets.js swaps the grid markup.
  var grid = document.getElementById('ProductGridContainer');
  if (grid && 'MutationObserver' in window) {
    new MutationObserver(function () { syncHearts(); }).observe(grid, { childList: true, subtree: true });
  }
})();
